module.exports = __webpack_public_path__ + "media/images/download-qrcode-de917ffb1ecbf94c5b8e7e5248374844.png";